import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../services/user.service'
import { ImageCroppedEvent } from 'ngx-image-cropper';

import { CheckEmail } from '../services/validators/check-email.validator'
import { CheckPassword } from '../services/validators/check-password.validator'
import { MatchFields } from '../services/validators/match-fields.validator'

import { fadeInUp } from '../services/animations/fadeInUp.animation'

@Component({
    selector: 'app-update-details',
    templateUrl: './update-details.component.html',
    animations: [fadeInUp]
})
export class UpdateDetailsComponent implements OnInit {
    currentUser: any
    updateDetails: FormGroup
    updateEmail: FormGroup
    updatePassword: FormGroup

    selectedAvatar: String = '0'
    updateDetailsChange: Boolean = false
    detailsErrors: Array<any> = []
    detailsMessage: Array<any> = []

    emailValidatorTimeout: any
    updateEmailChange: Boolean = false
    emailErrors: any = []
    emailMessage: any = []

    updatePasswordChange: Boolean = false
    passwordErrors: any = []
    passwordMessage: any = []

    abnValidatorTimeout: any
    abnFieldLabel: String = 'Business ABN'
    abnLength: Number = 11
    checkingAbn: boolean = false

    mongooseUniqueValueError = 11000

	imageChangedEvent: any = '';
	croppedImage: any = '';
	fileName: any = '';

    constructor(
        private userService: UserService,
        private fbuilder: FormBuilder
    ) {
        this.getCurrentUser()
    }

    ngOnInit() {
    }

    getCurrentUser() {
        this.userService.getCurrentUser()
        this.userService.currentUser.subscribe((currentUser) => {
            this.currentUser = currentUser
            this.selectedAvatar = this.currentUser.avatar
            this.formBuilders()
        })
    }

    formBuilders() {
        this.updateDetails = this.fbuilder.group({
            'userId': [this.currentUser._id, Validators.compose([Validators.required])],
            'firstName': [this.currentUser.firstName, Validators.compose([Validators.required, Validators.minLength(2)])],
            'lastName': [this.currentUser.lastName, Validators.compose([Validators.required, Validators.minLength(2)])],
            'gender': [this.currentUser.gender, Validators.compose([Validators.required])],
            'avatar': [this.currentUser.avatar, Validators.compose([Validators.required])],
            'businessName': [null],
            'profileImage': [null],
			'nickName': [null],
            'jobTitle': [null],
            'abn': [null],
            'optIn': [this.currentUser.optIn ? true : false]
        })

        if (this.currentUser.userType === 'Employer') {
            this.updateDetails.controls['businessName'].setValue(this.currentUser.businessName)
            this.updateDetails.controls['businessName'].setValidators([Validators.required]);
            this.updateDetails.controls['jobTitle'].setValue(this.currentUser.jobTitle)
            this.updateDetails.controls['jobTitle'].setValidators([Validators.required]);
            this.updateDetails.controls['abn'].setValue(this.currentUser.abn)
            this.updateDetails.controls['abn'].setValidators([Validators.required]);
        }
		if (this.currentUser.userType === 'Student') {
			this.updateDetails.controls['nickName'].setValue(this.currentUser.nickName)
			this.updateDetails.controls['nickName'].setValidators([Validators.required, Validators.minLength(2)]);
		}
		if (this.currentUser.profileImage) {
			this.updateDetails.controls['profileImage'].setValue(this.currentUser.profileImage)
		}

        this.updateEmail = this.fbuilder.group({
            'userId': [this.currentUser._id, Validators.compose([Validators.required])],
            'email': [this.currentUser.email, Validators.compose([Validators.required, CheckEmail])],
            'emailConfirm': [null, Validators.compose([Validators.required, MatchFields('email')])],
        })

        this.updatePassword = this.fbuilder.group({
            'userId': [this.currentUser._id, Validators.compose([Validators.required])],
            'newPassword': [null, Validators.compose([CheckPassword])],
            'newPasswordConfirm': [null, Validators.compose([Validators.required, MatchFields('newPassword')])],
        })
        this.formChanges()
    }

    formChanges() {
        this.updateDetailsChange = false
        this.updatePasswordChange = false
        this.updateEmailChange = false

        this.updateDetails.valueChanges.subscribe(val => {
            this.detailsErrors = []
            this.detailsMessage = []
            this.updateDetailsChange = false
            if (val.firstName !== this.currentUser.firstName) {
                this.updateDetailsChange = true
            }
            if (val.lastName !== this.currentUser.lastName) {
                this.updateDetailsChange = true
            }
            if (val.gender !== this.currentUser.gender) {
                this.updateDetailsChange = true
            }
            if (val.avatar !== this.currentUser.avatar) {
                this.updateDetailsChange = true
            }
            if (val.profileImage !== this.currentUser.profileImage) {
                this.updateDetailsChange = true
            }
            if (this.currentUser.userType === 'Student' && val.nickName !== this.currentUser.nickName) {
                this.updateDetailsChange = true
            }
            if (this.currentUser.userType === 'Employer' && val.businessName !== this.currentUser.businessName) {
                this.updateDetailsChange = true
            }
            if (this.currentUser.userType === 'Employer' && val.jobTitle !== this.currentUser.jobTitle) {
                this.updateDetailsChange = true
            }
            if (this.currentUser.userType === 'Employer' && val.abn && val.abn.toString() !== this.currentUser.abn) {
                this.updateDetailsChange = true
            }
            if (val.optIn !== this.currentUser.optIn) {
                this.updateDetailsChange = true
            }
        })

        this.updateDetails.controls['abn'].valueChanges.subscribe(val => {
            if (this.currentUser.userType === 'Employer') {
                this.validateABN(val)
            }
        })

        this.updateEmail.valueChanges.subscribe(val => {
            this.emailErrors = []
            this.emailMessage = []
            this.updateEmailChange = false
            if (val.email !== this.currentUser.email) {
                this.updateEmailChange = true
                this.checkEmailAvailable(val.email)
            }
        })

        this.updatePassword.valueChanges.subscribe(val => {
            this.passwordErrors = []
            this.passwordMessage = []
            this.updatePasswordChange = false
            if (val.newPassword && val.newPassword !== '') {
                this.updatePasswordChange = true
            }
        })
    }

    resetForm() {
        this.selectedAvatar = this.currentUser.avatar
		this.croppedImage = null
        this.formBuilders()
    }

    openOverlay(target) {
        document.getElementsByTagName('html')[0].classList.add('scroll-lock')
        document.getElementById(target).classList.add('is-block')
        setTimeout(function () {
            document.getElementById(target).classList.add('is-visible')
        }, 10)
		if (target == 'overlay-selectavatar' && !this.croppedImage) {
			document.getElementById("selectFileInput").click();
		}
    }

    closeOverlay(target) {
        document.getElementsByTagName('html')[0].classList.remove('scroll-lock')
        document.getElementById(target).classList.remove('is-visible')
        setTimeout(function () {
            document.getElementById(target).classList.remove('is-block')
        }, 500)
    }

    selectAvatar(value) {
        if (value) {
            this.selectedAvatar = value
            this.updateDetails.controls['avatar'].setValue(value)
        }
    }

    checkEmailAvailable(value) {
        clearTimeout(this.emailValidatorTimeout)
        this.emailValidatorTimeout = setTimeout(() => {
            const data = { email: value }
            this.userService.checkEmailAvailable(data).subscribe((res: any) => {
                if (!res) {
                    this.updateEmail.controls['email'].setErrors({ 'emailTaken': true })
                }
            })
        }, 600)
    }

    validateABN(value: Number) {
        if (value && value.toString().length === this.abnLength) {
            this.checkingAbn = true
            clearTimeout(this.abnValidatorTimeout)
            this.abnValidatorTimeout = setTimeout(() => {
                const data = { abn: value }
                this.userService.checkABN(data).subscribe((res: any) => {
                    if (res) {
                        this.abnFieldLabel = res.EntityName
                    } else {
                        this.abnFieldLabel = 'Business ABN'
                        this.updateDetails.controls['abn'].setErrors({ 'invalidAbn': true })
                    }
                    this.checkingAbn = false
                })
            }, 600)
        } else {
            this.abnFieldLabel = 'Business ABN'
            this.updateDetails.controls['abn'].setErrors({ 'invalidAbn': true })
        }
    }

	fileChangeEvent(event: any): void {
		this.imageChangedEvent = event;
		if (event.target.value) {
			this.fileName = event.target.value.split(/(\\|\/)/g).pop()
		}
	}
	imageCropped(event: ImageCroppedEvent) {
		this.croppedImage = event.base64;
		this.updateDetails.controls['profileImage'].setValue(this.croppedImage)
	}
	imageLoaded() {
		// show cropper
	}
	cropperReady() {
		// cropper ready
	}
	loadImageFailed() {
		// show message
	}

    // Form Submissions
    submitUpdateDetails(isValid: boolean, submission) {
        if (isValid) {
            this.detailsErrors = []
            this.userService.updateUserDetails(submission).then(result => {
                this.getCurrentUser()
                this.detailsMessage = [{ message: 'Details updated successfully' }]
            }).catch(error => {
                let err = error.json()
                this.detailsErrors = err
            })
        }
    }

    submitUpdateEmail(isValid: boolean, submission) {
        if (isValid) {
            this.emailErrors = []
            this.userService.updateUserEmail(submission).then(result => {
                this.getCurrentUser()
                this.emailMessage = [{ message: 'Email updated successfully' }]
            }).catch(error => {
                let err = error.json()
                if (err && err.code && err.code === this.mongooseUniqueValueError) {
                    this.emailErrors.push({ msg: 'This email address is unavailable.' })
                } else {
                    this.emailErrors = err
                }
            })
        }
    }

    submitUpdatePassword(isValid: boolean, submission) {
        if (isValid) {
            this.passwordErrors = []
            this.userService.updateUserPassword(submission).then(result => {
                this.getCurrentUser()
                this.passwordMessage = [{ message: 'Password updated successfully' }]
            }).catch(error => {
                let err = error.json()
                this.passwordErrors = err
            })
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/user/update-details.component.ts